import styled from "@emotion/styled";
import { black, useViewportWidth } from "@stepfinance/react";
import { Layout } from "antd";
import type { SiderProps } from "antd/lib/layout/Sider";
import type { MenuClickEventHandler, MenuInfo } from "rc-menu/lib/interface";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useNavigationContext } from "../../contexts/navigation";
import { SIDENAV_WIDTH } from ".";
import { HeaderLogoComponent } from "./HeaderLogoComponent";
import { MenuItems } from "./MenuItems";
import { MobileMenu } from "./SideMenu";

const { Sider } = Layout;

export const SideNavComponent: React.FC = () => {
  const { currentViewport } = useViewportWidth();
  const { navigate } = useNavigationContext();
  const location = useLocation();

  const [sideNavCollapsed, setSideNavCollapsed] = useState<boolean>(true);
  const [selectedMenuKey, setSelectedMenuKey] = useState<string[] | undefined>(undefined);

  const onItemSelect: MenuClickEventHandler = useCallback(
    (item: MenuInfo) => {
      if (!item.key.includes("outbound")) {
        navigate(`/` + item.key);
      }
    },
    [navigate],
  );

  useEffect(() => {
    const formattedPathname = location.pathname.split(`/`)[2];
    setSelectedMenuKey([formattedPathname]);
  }, [location.pathname]);

  useEffect(() => {
    if (!sideNavCollapsed) {
      setSideNavCollapsed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentViewport]);

  return currentViewport === "Mobile" ? (
    <MobileMenu selectedMenuKey={selectedMenuKey} onItemSelect={onItemSelect} />
  ) : (
    <LayoutSider width={SIDENAV_WIDTH}>
      <HeaderLogoComponent />
      <MenuItems selectedMenuKey={selectedMenuKey} onItemSelect={onItemSelect} />
    </LayoutSider>
  );
};

const LayoutSider = styled(Sider)<SiderProps>`
  position: fixed;
  background: ${black};
  height: 100%;
  padding: 14px 12px;
  overflow-y: auto;
  z-index: 2;
`;
